import {Component, OnInit} from '@angular/core';
import {Route, Router} from '@angular/router';
import {navigation} from '../../../../app-navigation';
import {FusionAuthService} from '../../../services/fusion-auth';
import {PWADetectorService} from '../../../services/general';
import {LabSettingsService} from "../../../services/ocl";
import {take} from "rxjs/operators";

@Component({
  selector: 'app-top-navigation-menu',
  templateUrl: './top-navigation-menu.component.html',
  styleUrls: ['./top-navigation-menu.component.scss']
})
export class TopNavigationMenuComponent implements OnInit {
  public routes = navigation;
  public role?: string;

  constructor(private router: Router, private pwaDetectorService: PWADetectorService, public fusionAuthService: FusionAuthService, public labSettingService: LabSettingsService) {
  }

  public ngOnInit() {
    this.waitForUser();

  }

  private waitForUser() {
    if (localStorage.getItem('authtoken')) {
      this.role = this.fusionAuthService.Profile.registrations[0].roles[0];
      this.labSettingService.getResultEntrySettings().pipe(take(1))
        .subscribe(config => {
          if (config.resultEntryEnabled) {
            const route = this.routes.find(r => r.path === 'result-entry');
            if (route) {
              const registrations = this.fusionAuthService.Profile.registrations;
              if (config.resultEntrySuperUser && registrations[0].roles.includes("Superuser")) {
                route.hidden = false;
              } else if (config.resultEntryClientAdmin && registrations[0].roles.includes("Client Admin")) {
                route.hidden = false;
              } else if (config.resultEntryClientBasic && registrations[0].roles.includes("Client Basic")) {
                route.hidden = false;
              } else
                route.hidden = true;
            }
          }
        })

      const route = this.routes.find(r => r.path === 'result-export');
      if (route) {
        const registrations = this.fusionAuthService.Profile.registrations;

        if (registrations[0].roles.includes("Superuser")) {
            route.hidden = false;
        } else if (registrations[0].roles.includes("Client Admin")) {
            route.hidden = false;
        } else route.hidden = !registrations[0].roles.includes("Client Basic");
      }
    } else {
      setTimeout(() => {
        this.waitForUser();
      }, 1000);
    }
  }

  public isChildrenActivated(routes: any[]): boolean {
    return routes.some((route: any) => this.router.url.includes(route.path));
  }

  public filter(items: any[]) {
    return items.filter(x => x.roles.indexOf(this.role) !== -1);
  }

  public RouteTarget(route: Route) {
    return route.path === 'requisitions/create' && !this.pwaDetectorService.isPWA() ? '_blank' : '_self';
  }
}
